import type { CustomErrorRule } from '@/core/error/transport/types'
import { tmApiPrivacyPolicyAlreadyAcceptedError } from '@/core/error/transport/tmApiPrivacyPolicyAlreadyAcceptedError'

export const privacyPolicyAlreadyAcceptedErrorRule: CustomErrorRule = {
  klass: tmApiPrivacyPolicyAlreadyAcceptedError,
  predicateFn: (error) => {
    return error.response.data.message.includes('already been accepted')
  },
}
